export function prepareHelper(html: string, title: string = "") {
  return {
    title,
    html,
  };
}
